import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { setUserToLS } from '../../helpers/localstorage-helper';
import { BIG_WHALE, ENTRY_PACKAGE } from '../../routes/routes';
import { changeUserInfo } from '../../slices/auth-slice';
import {
  checkSideModalAsync,
  getDashboardAsync,
  getJoinedAfterUsersAsync,
  getLastRegisteredUsersAsync,
  updatePackageRankNotificationAsync,
  getWillyCoinsAsync,
  firstLoginAsync,
  getTeamBonusAsync
} from './Dashboard.requests';
import { WillyDataResponse } from './Dashboard.types';

export const getDashboardInfo = createAsyncThunk(
  'auth/getDashboardInfo',
  async () => {
    const dashboardInfo = await getDashboardAsync();
    const bonusInfo = await getTeamBonusAsync();

    return {
      dashboardInfo,
      bonusInfo
    };
  }
);

export const updatePackageRankNotification = createAsyncThunk(
  'auth/updatePackageRankNotification',
  async (id: number) => {
    await updatePackageRankNotificationAsync(id);
    return id;
  }
);

export const checkSideModal = createAsyncThunk(
  'auth/checkSideModal',
  async (
    history: {
      push(url: string): void;
    },
    { getState, dispatch }
  ) => {
    await checkSideModalAsync();

    const state = getState() as RootState;

    const user = {
      ...state.auth.userInfo,
      isSideModalChecked: true,
      isisFirstLoginPopupChecked: true
    };

    dispatch(changeUserInfo(user));

    setUserToLS(user);
  }
);

export const firstLogin = createAsyncThunk(
  'auth/firstLogin',
  async (
    history: {
      push(url: string): void;
    },
    { getState, dispatch }
  ) => {
    await firstLoginAsync();

    const state = getState() as RootState;

    const user = {
      ...state.auth.userInfo,
      isSideModalChecked: true,
      isFirstLoginPopupChecked: true
    };

    dispatch(changeUserInfo(user));

    setUserToLS(user);

    history.push(ENTRY_PACKAGE);
  }
);

export const updateWillyCoins = createAsyncThunk(
  'auth/updateWillyCoins',
  ({ totalCoins, coinsPerChange }: WillyDataResponse) => {
    let willyCoins = {
      totalCoins: (totalCoins += coinsPerChange)
    };

    return willyCoins;
  }
);
